import axios from 'axios'
import { hasBillingIssue } from '../../../helpers/billing-helper'

const getPaymentMethods = async ({ commit, rootState }, orgId) => {
  const response = await axios.get(`${rootState.baseURL}/billing/organization/paymentmethods/${orgId}`)
  const { data } = response.data

  commit('updatePaymentMethods', data || [])
}

const getSubscriptions = async ({ commit, rootState }, orgId) => {
  const response = await axios.get(`${rootState.baseURL}/subscriptions/organization/${orgId}`)
  const { data } = response.data

  commit('updateSubscriptions', data || [])

  const subCount = data.length
  let activeSub = data[0] || {}

  if (subCount > 1) {
    if (!hasBillingIssue(activeSub.status)) {
      for (let i = 1; i < subCount; i++) {
        const sub = data[i]

        if (hasBillingIssue(sub.status)) {
          activeSub = sub
          break
        }
      }
    }
  }

  commit('setSubscription', activeSub)
  commit('Users/updateOrgSubStatus', {
    orgId: orgId,
    subStatus: activeSub.status || 'unknown',
  }, { root: true })
}

const attachSourceToOrg = async ({ rootState, dispatch }, payload) => {
  const response = await axios.post(`${rootState.baseURL}/billing/organization/sources`, payload)

  if (response && response.status === 200) {
    const toastPayload = {
      type: 'success',
      text: 'New Payment Information Saved!',
    }

    dispatch('updateMessages', toastPayload, { root: true })
  }
}

export default {
  getPaymentMethods,
  getSubscriptions,
  attachSourceToOrg,
}
